<template>
  <div class="admin-panel task-page task-page--email-blast">

    <admin-header
      variant="back"
      :crumbs="[{ label: 'Client Management', to: { name: 'Admin-Panel', params: { lang: $route.params.lang } } }, { label: 'Email Blast' }]"
      :back-to="{ name: 'Admin-Panel', params: { lang: $route.params.lang } }"
      @open-logout="openLogoutModal"
    />

    <main class="ap-container ap-fade-in">

      <div class="tp-hero">
        <div class="tp-hero-icon">
          <fa-icon :icon="['fas', 'paper-plane']" />
        </div>
        <div>
          <h1 class="tp-hero-title">Email Blast</h1>
          <p class="tp-hero-sub">Send bulk deadline notifications to clients using pre-built email templates.</p>
        </div>
      </div>

      <div class="eb-section-label">Choose a template</div>

      <div class="eb-templates">
        <div
          class="eb-template-card"
          @click="$router.push({ name: 'Admin-Email-Blast-Monthly', params: { lang: $route.params.lang } })"
        >
          <div class="eb-template-icon">
            <fa-icon :icon="['fas', 'calendar-alt']" />
          </div>
          <div class="eb-template-body">
            <div>
              <h3 class="eb-template-title">Monthly Deadlines</h3>
              <p class="eb-template-desc">Send deadline reminders to all clients with upcoming deadlines for the current month. Combines tax and cosec / business support deadlines into a single email per client.</p>
            </div>
          </div>
          <div class="eb-template-arrow">
              <fa-icon :icon="['fas', 'chevron-right']" />
            </div>
        </div>

        <div
          class="eb-template-card"
          @click="$router.push({ name: 'Admin-Email-Blast-General', params: { lang: $route.params.lang } })"
        >
          <div class="eb-template-icon">
            <fa-icon :icon="['fas', 'envelope-open-text']" />
          </div>
          <div class="eb-template-body">
            <div>
              <h3 class="eb-template-title">General Blast</h3>
              <p class="eb-template-desc">Compose a fully custom email and send it to any filtered group of clients. Filter by business type, service, year end, task status, and more — then blast to the matched recipients.</p>
            </div>
          </div>
          <div class="eb-template-arrow">
            <fa-icon :icon="['fas', 'chevron-right']" />
          </div>
        </div>
      </div>

    </main>

    <confirm-modal
      :show="showLogoutModal"
      title="Confirm Logout"
      confirm-label="Logout"
      :icon="['fas', 'sign-out-alt']"
      @cancel="closeLogoutModal"
      @confirm="confirmLogout"
    >Are you sure you want to logout?</confirm-modal>

    <session-modal :show="showAdminSessionModal" @continue="continueAdminSession" @signout="signOutAdminSession">
      Your admin session has expired. Continue to refresh your session or sign out.
    </session-modal>

  </div>
</template>

<script>
import adminSessionMixin from '@/mixins/adminSessionMixin'
import AdminHeader from '@/components/admin/AdminHeader.vue'
import ConfirmModal from '@/components/shared/ConfirmModal.vue'
import SessionModal from '@/components/shared/SessionModal.vue'

export default {
  name: 'admin-email-blast',
  mixins: [adminSessionMixin],
  components: { AdminHeader, ConfirmModal, SessionModal },
  mounted () {
    this.startSessionTimer()
  }
}
</script>
